const _ = require('lodash');

module.exports = function () {
    return {
        restrict: 'EA',
        replace: true,
        transclude: true,
        scope: {
            name: '@',
            onFinish: '&',
            startStep: '@'
        },
        template: '<div ng-transclude></div>',
        controller: [
            '$scope', '$element', 'WizardRegistry', function ($scope, $element, wizardRegistry) {
                this.$onInit = function() {
                    wizardRegistry.addWizard(this, $scope.name);
                    $scope.$on('$destroy', wizardRegistry.removeWizard.bind(wizardRegistry, $scope.name));

                    $scope.steps = [];

                    function unselectAll() {
                        _.each($scope.steps, function (step) {
                            step.selected = false;
                        });

                        $scope.selectedStep = null;
                    }

                    $scope.goTo = function (step) {
                        unselectAll();

                        $scope.selectedStep = step;


                        step.selected = true;
                    };

                    this.displayStepSelection = function (step) {
                        const targetStep = _.isNumber(step)
                            ? $scope.steps[step]
                            : _.find($scope.steps, { name: step });
                        return _.indexOf($scope.steps, targetStep) < this.currentStepIndex();
                    };

                    this.isStepActive = function (step) {
                        const targetStep = _.isNumber(step)
                            ? $scope.steps[step]
                            : _.find($scope.steps, { name: step });
                        return _.indexOf($scope.steps, targetStep) === this.currentStepIndex();
                    };

                    this.isCurrentStep = function (step) {
                        return $scope.steps.indexOf(step) === $scope.selectedStep;
                    };

                    this.addStep = function (step) {
                        $scope.steps.push(step);

                        if ($scope.steps.length === 1) {
                            // If this is the first step we are adding, go to it.
                            $scope.goTo($scope.steps[0]);
                        }
                    };

                    this.currentStep = function () {
                        return $scope.selectedStep;
                    };

                    this.currentStepIndex = function () {
                        return _.indexOf($scope.steps, $scope.selectedStep);
                    };

                    this.goTo = function (step) {
                        const stepTo = _.isNumber(step)
                            ? $scope.steps[step]
                            : _.find($scope.steps, { name: step });
                        $scope.goTo(stepTo);
                    };

                    this.finish = function () {
                        if ($scope.onFinish) {
                            $scope.onFinish();
                        }
                    };

                    this.next = function () {
                        const index = _.indexOf($scope.steps, $scope.selectedStep);
                        if (index === $scope.steps.length - 1) {
                            this.finish();
                        } else {
                            $scope.goTo($scope.steps[index + 1]);
                        }
                    };

                    this.cancel = this.previous = function () {
                        const index = _.indexOf($scope.steps, $scope.selectedStep);
                        if (index !== 0) {
                            $scope.goTo($scope.steps[index - 1]);
                        }
                    };

                    this.stepOfSteps = function () {
                        return (this.currentStepIndex() + 1) + ' of ' + $scope.steps.length;
                    };

                    this.restart = this.goTo.bind(this, 0);
                };
            }
        ],
        link(scope) {
            if (scope.startStep) {
                const stepTo = _.isNumber(scope.startStep)
                    ? scope.steps[scope.startStep]
                    : _.find(scope.steps, { name: scope.startStep });
                scope.goTo(stepTo);
            }
        }
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/wizard/wizard-directive.js
 **/